import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Popover, IconButton, Text, Layout } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import { InfoIconWrapper, StatusWrapper, StatusTitle, StatusDot } from './VehicleCard.styles';
import { device } from '../../styles/devices';

interface IStatusProps {
  statusForDot: string;
  vehicleStatus: string;
  popoverDescription: string;
  iconColor?: string;
}

const ButtonStyled = styled(IconButton)`
  margin: 0;
`;
const Content = styled.div`
  @media ${device.tablet} {
    width: 290px;
  }
`;

const Status: React.FC<IStatusProps> = ({ statusForDot, vehicleStatus, popoverDescription }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const ref = useRef<HTMLDivElement | null>(null);
  return (
    <StatusWrapper ref={ref}>
      <Layout align="center" direction="row">
        <StatusDot
          statusForDot={statusForDot}
          data-cy="vehicle-card-status-dot"
          data-testid="vehicle-card-status-dot"
        />
        <StatusTitle data-testid="availability-status" id="status" data-cy="vehicle-card-status">
          {vehicleStatus}
        </StatusTitle>
        <InfoIconWrapper>
          <Popover
            aria-label="status_popover"
            id="status_popover"
            triggerElement={
              <ButtonStyled
                variant="tertiary"
                icon="info-circle"
                size="sm"
                onClick={() => setIsOpen(!isOpen)}
              />
            }
            open={isOpen}
            content={
              <Content>
                <Text>{popoverDescription}</Text>
              </Content>
            }
            onClose={() => setIsOpen(false)}
            withTip
          />
        </InfoIconWrapper>
      </Layout>
    </StatusWrapper>
  );
};

export default Status;
